import { Text } from '@chakra-ui/react';
import { SpinnerWithLabel } from '@texas/components/shared/SpinnerWithLabel';
import { ServerError } from '@texas/types';
import { useTranslation } from 'react-i18next';

interface Props {
  children: React.ReactNode;
  loading: boolean;
  error: ServerError | null;
}

export function ComponentLoader({ children, loading, error }: Props) {
  const { t } = useTranslation();
  if (loading) {
    return <SpinnerWithLabel label={t('ai.components.loading')} />;
  } else if (error) {
    return <Text>{t('ai.components.error')}</Text>;
  }

  return <>{children}</>;
}
